import { render, staticRenderFns } from "./InputWithPrefix.vue?vue&type=template&id=4d045dc2&lang=pug"
import script from "./InputWithPrefix.vue?vue&type=script&lang=js"
export * from "./InputWithPrefix.vue?vue&type=script&lang=js"
import style0 from "./InputWithPrefix.vue?vue&type=style&index=0&id=4d045dc2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports